import { useCallback, useEffect, useState } from 'react';
import ConfigPanel from './ConfigPanel';
import CampaignList from './CampaignList';
import { NAMI_SDK_STATE_KEY } from '../../utils/const';

interface SdkState {
  sdkInitialized?: boolean;
  [key: string]: unknown;
}

const getSdkState = (): SdkState | undefined => {
  try {
    const raw = localStorage.getItem(NAMI_SDK_STATE_KEY);
    return raw ? (JSON.parse(raw) as SdkState) : undefined;
  } catch (error) {
    console.warn('Unable to read SDK state from storage', error);
    return undefined;
  }
};

const CampaignsPage = () => {
  const [sdkState, setSdkState] = useState<SdkState | undefined>(() => getSdkState());

  const refreshState = useCallback(() => {
    setSdkState(getSdkState());
  }, []);

  useEffect(() => {
    refreshState();
  }, [refreshState]);

  const configured = Boolean(sdkState?.sdkInitialized);

  return (
    <div className="screen-root">
      {configured ? (
        <CampaignList onReset={() => setSdkState(undefined)} />
      ) : (
        <ConfigPanel onConfigured={refreshState} />
      )}
    </div>
  );
};

export default CampaignsPage;
